import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { IComboBox } from "@interfaces/IComboBox";
import { DynamicReportService } from "@reports/_services/dynamicReports.service";
import { ReportTableRowDataSource } from "@reports/enums/ReportTableRowDataSource";
import { IColumnHeader } from "@reports/models/IColumnHeader";
import { IOnChangesObject } from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import "./row-data-source-selector2.component.scss";

export interface IRowDataSourceOption extends IComboBox {
    disableSubRowOptions?: boolean;
}

//export interface IComponentBindings {
//    row: ReportTableRowDataSource;
//    subRow: ReportTableRowDataSource;
//    columns: IColumnHeader[];

//    horizontal: boolean;
//    hideSubGroups: boolean;

//    onChange: (args: { $row: ReportTableRowDataSource, $subRow: ReportTableRowDataSource, rowTitleColumn: IColumnHeader }) => void;
//}

export interface IRowDataSourceChange {
    row: ReportTableRowDataSource;
    subRow: ReportTableRowDataSource;
    rowTitleColumn: IColumnHeader;
}

@Component({
    selector: "row-data-source-selector2",
    template: require("./row-data-source-selector2.component.html")
})
export class RowDataSourceSelectorComponent2 implements OnChanges {
    @Input() row: ReportTableRowDataSource;
    @Input() subRow: ReportTableRowDataSource;
    @Input() columns: IColumnHeader[];
    @Input() horizontal: boolean;
    @Input() hideSubGroups: boolean;

    @Output() change = new EventEmitter<IRowDataSourceChange>();

    selectedRowOption: IRowDataSourceOption;
    selectedSubRowOption: IRowDataSourceOption;

    originalRowDataSourceOptions: IRowDataSourceOption[] = [
        { Name: "Driver", Value: ReportTableRowDataSource.Driver },
        { Name: "Vehicle", Value: ReportTableRowDataSource.Vehicle },
        { Name: "Day", Value: ReportTableRowDataSource.Day },
        { Name: "Week", Value: ReportTableRowDataSource.Week },
        { Name: "DriverGroup", Value: ReportTableRowDataSource.DriverGroup },
        { Name: "VehicleGroup", Value: ReportTableRowDataSource.VehicleGroup },
        { Name: "VehicleDepot", Value: ReportTableRowDataSource.VehicleDepot }
    ];

    originalSubRowDataSourceOptions: IRowDataSourceOption[] = [
        { Name: "None", Value: ReportTableRowDataSource.None },
        { Name: "Driver", Value: ReportTableRowDataSource.Driver },
        { Name: "Vehicle", Value: ReportTableRowDataSource.Vehicle },
        { Name: "Day", Value: ReportTableRowDataSource.Day },
        { Name: "Week", Value: ReportTableRowDataSource.Week },
        { Name: "GeofenceVisit", Value: ReportTableRowDataSource.GeofenceVisits },
        { Name: "Journey", Value: ReportTableRowDataSource.Journey },
        { Name: "StationaryLocation", Value: ReportTableRowDataSource.StationaryLocations },
        { Name: "Route", Value: ReportTableRowDataSource.Route },
        { Name: "Temperature", Value: ReportTableRowDataSource.TemperatureRecord },
        { Name: "Alcolock", Value: ReportTableRowDataSource.AlcolockRecord },
        { Name: "TrailerAssociation", Value: ReportTableRowDataSource.TrailerAssociation },
        { Name: "VehicleInput", Value: ReportTableRowDataSource.VehicleInput },
        { Name: "CameraEvent", Value: ReportTableRowDataSource.CameraEvent },
        { Name: "VehicleEvent", Value: ReportTableRowDataSource.CommonEvent }
    ];

    rowDataSourceOptions: IRowDataSourceOption[] = [];
    subRowDataSourceOptions: IRowDataSourceOption[] = [];

    constructor(
        private readonly reportService: DynamicReportService
    ) {
    }

    ngOnChanges(onChangesObj: IOnChangesObject): void {
        this.setRowsForDataSource();
        this.setSubRowsForDataSource();
        this.addSupportedDataSources();
        this.validateSelection();
        this.setSelectedOptions();
    }

    setSelectedOptions(): void {
        this.rowDataSourceOptions.forEach(option => {
            if (option.Value === this.row) {
                this.selectedRowOption = option;
            }
        });

        this.subRowDataSourceOptions.forEach(option => {
            if (option.Value === this.subRow) {
                this.selectedSubRowOption = option;
            }
        });
    }

    rowDataSourceChanged(): void {
        this.row = Number(this.selectedRowOption.Value);
        this.subRow = Number(this.selectedSubRowOption.Value);

        if (this.selectedRowOption.disableSubRowOptions) {
            this.selectedSubRowOption = this.subRowDataSourceOptions[0];
            this.subRow = ReportTableRowDataSource.None;
        }

        this.setSubRowsForDataSource();

        const rowTitleColumn: IColumnHeader = {
            Title: this.getTitleForRowDataSource(),
            IsRowTitle: true
        };

        this.change.emit({
            row: this.row,
            subRow: this.subRow,
            rowTitleColumn: rowTitleColumn
        });
    }

    private setRowsForDataSource(): void {
        this.rowDataSourceOptions = [];

        this.rowDataSourceOptions = copy(this.originalRowDataSourceOptions);
    }

    private setSubRowsForDataSource(): void {
        this.subRowDataSourceOptions = [];

        this.originalSubRowDataSourceOptions.forEach(combo => {
            if (ReportTableRowDataSource[combo.Value] === ReportTableRowDataSource[this.row]) {
                return;
            }

            if (ReportTableRowDataSource[this.subRow] === ReportTableRowDataSource[this.row]) {
                this.subRow = ReportTableRowDataSource.None;
            }

            this.subRowDataSourceOptions.push(combo);
        });
    }

    private addSupportedDataSources(): void {
        var geofenceColumns = this.reportService.findColumnsOfType("GeofenceVisit", this.columns);

        if (geofenceColumns.length > 0) {
            this.rowDataSourceOptions.push({ Name: "Geofence", Value: ReportTableRowDataSource.Geofence });
        }

        if (this.reportService.findColumn("MaxVehicleSpeed", "CommonEvent", this.columns) ||
            this.reportService.findColumn("RoadSpeed", "CommonEvent", this.columns) ||
            this.reportService.findColumn("RoadType", "CommonEvent", this.columns) ||
            this.reportService.findColumn("RoadTypeDisplay", "CommonEvent", this.columns) ||
            this.reportService.findColumn("StartLocation", "CommonEvent", this.columns)) {
            this.rowDataSourceOptions.push({ Name: "Road Type", Value: ReportTableRowDataSource.RoadType });
            this.subRowDataSourceOptions.push({ Name: "Road Type", Value: ReportTableRowDataSource.RoadType });
        }
        
        if (this.reportService.findColumnsOfType("FormSubmission", this.columns).length) {
            this.rowDataSourceOptions.push({ Name: "FormSubmission", Value: ReportTableRowDataSource.FormSubmission, disableSubRowOptions: true });
        }

        this.rowDataSourceOptions.push({ Name: "FormSubmission", Value: ReportTableRowDataSource.FormSubmission, disableSubRowOptions: true });
    }

    private validateSelection(): void {
        let rowFound = false;

        for (var i = 0; i < this.rowDataSourceOptions.length; i++) {
            if (this.rowDataSourceOptions[i].Value === this.row) {
                rowFound = true;
                break;
            }
        }

        if (!rowFound) {
            this.row = this.rowDataSourceOptions[0].Value;
        }

        let subRowFound = false;
        for (var i = 0; i < this.subRowDataSourceOptions.length; i++) {
            if (this.subRowDataSourceOptions[i].Value === this.subRow) {
                subRowFound = true;
                break;
            }
        }

        if (!subRowFound) {
            this.subRow = 0;
        }
    }

    private getTitleForRowDataSource(): string {
        switch (this.row) {
            case ReportTableRowDataSource.Day:
                return "Day";
            case ReportTableRowDataSource.Week:
                return "Week";
            case ReportTableRowDataSource.Driver:
                return "Driver";
            case ReportTableRowDataSource.Vehicle:
                return "Vehicle";
            case ReportTableRowDataSource.DriverGroup:
                return "Driver Group";
            case ReportTableRowDataSource.VehicleGroup:
                return "Vehicle Group";
            case ReportTableRowDataSource.Geofence:
                return "Geofence";
            case ReportTableRowDataSource.Journey:
                return "Journey";
            case ReportTableRowDataSource.Route:
                return "Route";
            case ReportTableRowDataSource.StationaryLocations:
                return "Stationary Location";
            case ReportTableRowDataSource.TemperatureRecord:
                return "Temperature Record";
            case ReportTableRowDataSource.TrailerAssociation:
                return "Trailer Association";
        }

        return ReportTableRowDataSource[this.row];
    }
}
